import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  widgetList: [],
  selectedWidget: "",
  selectedWidget: [],
  widgetNewsList: [],
};

const WidgetReducer = createSlice({
  name: "WidgetReducer",
  initialState: initialState,
  reducers: {
    setWidgetList: (state, { payload }) => {
      return {
        ...state,
        widgetList: payload,
      };
    },

    setSelectWidget: (state, { payload }) => {
      return {
        ...state,
        selectedWidget: payload,
      };
    },

    updateWidgetList: (state, { payload }) => {
      let newList = [...state.widgetList];
      for (let index = 0; index < newList.length; index++) {
        if (newList[index].widget_id === payload.widget_id) {
          newList[index] = payload;
        }
      }
      return {
        ...state,
        widgetList: newList,
      };
    },

    addList: (state, { payload }) => {
      let newList = [...state.tagsList];
      newList.push(payload);
      return {
        ...state,
        tagsList: newList,
        // selectedTags: [...state.selectedTags, payload.tag_id],
        newTag: payload,
        isUpdateTagList: true,
      };
    },

    setWidgetNewsList: (state, { payload }) => {
      return {
        ...state,
        widgetNewsList: payload,
      };
    },

    setSelectedTags: (state, { payload }) => {
      return {
        ...state,
        selectedTags: payload,
      };
    },

    clearNewTag: (state) => {
      return {
        ...state,
        newTag: "",
      };
    },

    clearSelectItems: (state) => {
      return {
        ...state,
        selectedWidget: "",
        selectedWidget: [],
      };
    },
  },
});
export default WidgetReducer;
